import tw from 'twin.macro';

import { theme } from '../../tailwind.config';

/** The light floating panel: Popover content and the light Tooltip. */
export const lightPanelStyles = tw`bg-white rounded shadow-md border`;

/** FloatingArrow props for a light panel: white, with the panel's gray border. */
export const lightArrowProps = {
	strokeWidth: 1,
	stroke: theme.colors.gray[200],
	fill: theme.colors.white,
} as const;
